import React from "react";
import { useMediaQuery, Box, IconButton } from "@mui/material";
import { socialMediaBox } from "../styles/styles";

const phoneIcon = "../../images/icons/phone.png";
const whatsappIcon = "../../images/icons/whatsapp.png";
const emailIcon = "../../images/icons/envelope.png";
const instagramIcon = "../../images/icons/instagram.png";

const SocialMediaBar = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  // const isTab = useMediaQuery('(max-width:770px)')

  const socialMediaIcons = [
    {
      label: "Phone",
      icon: phoneIcon,
      link: "tel:+2347026676995",
      type: "phone",
    },
    {
      label: "WhatsApp",
      icon: whatsappIcon,
      link: "https://wa.me/2347026676995",
      type: "whatsapp",
    },
    {
      label: "Email",
      icon: emailIcon,
      link: "mailto:baniluxillumina2@gmail.com",
      type: "email",
    },
    {
      label: "Instagram",
      icon: instagramIcon,
      link: "https://www.instagram.com/reel/DGix2zGMA7R/?igsh=MXN2aWUzdXo2aGlq",
      type: "instagram",
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        // gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
        gap: 0.5,
        width: "90%",
        margin: "auto",
        borderTop: "1px solid #7aa648",
        paddingTop: "2rem",
      }}
    >
      <Box sx={socialMediaBox}>
        {socialMediaIcons.map((item, index) => (
          <IconButton key={index}>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              <img
                src={item.icon}
                alt={item.label}
                style={{
                  width: isMobile ? "20px" : "30px",
                }}
              />
            </a>
          </IconButton>
        ))}
      </Box>
    </Box>
  );
};

export default SocialMediaBar;
